<bl-dynamic-guide-content #content
  [title]="title"
  [guideContents]="guideContents"
  (changeSelectRowEvent)="onSelectRow($event)"
>
</bl-dynamic-guide-content>



// WEBPACK FOOTER //
// ./src/app/feature/slip-print-detail-setting/tab/slip-print-detail-setting-for-header/company-name-select-guide/company-name-select-guide.component.html